import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class FarmAppGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let farmappAccess = localStorage.getItem('farm_access');
    if (farmappAccess !== undefined && farmappAccess !== null && farmappAccess !== '' && farmappAccess =='true') {
      return of(true);
    }
    else {
      this.router.navigate(['']);
      return of(false);
    }
  }
}